<div class="app-footer">
  <div class="footer-bottom" *ngIf="!personalization">
    <div class="container">
      <div class="logo-aar border-separador">
        <a routerLink="/">
          <img class="size-logo" src="./assets/images/logo-aar-horizontal-branco-ciano.png" alt="">
        </a>
      </div>
      <div class="row py-24">
        <div class="col-12 px-md-0">
          <div class="footer-menu-wrapper">
            <div class="d-flex flex-column width-links">
              <!-- <a class="link-footer title" [href]="getUrl('')" target="_blank">Auto Arremate</a> -->
              <span class="link-footer title">Soluções</span>
              <a class="link-footer" [href]="getUrl('solucoes-para-agentes-financeiros/')" target="_blank">Para agentes
                financeiros</a>
              <a class="link-footer" [href]="getUrl('solucoes-para-concessionarias/')" target="_blank">Para
                concessionárias</a>
              <a class="link-footer" [href]="getUrl('solucoes-para-locadoras/')" target="_blank">Para locadoras</a>
              <a class="link-footer" [href]="getUrl('solucoes-para-revendedores/')" target="_blank">Para
                revendedores</a>
            </div>
            <div class="d-flex flex-column width-links">
              <!-- <a class="link-footer title" [href]="getUrl('solucoes')" target="_blank">&nbsp;</a> -->
              <span class="link-footer title">Recursos</span>
              <a class="link-footer" [href]="getUrl('plugin-online/')" target="_blank">Plugin Auto Arremate®</a>
              <a class="link-footer" [href]="getUrl('versao-white-label/')" target="_blank">Versão White Label</a>
              <a class="link-footer" [href]="getUrl('aplicativo-raiox/')" target="_blank">Aplicativo RaioX</a>
              <a class="link-footer" [href]="getUrl('aplicativo-marketplace/')" target="_blank">Aplicativo Exchange</a>
              <!-- <a class="link-footer" [href]="getUrl('raiox/')" target="_blank">RaioX</a>
              <a class="link-footer" [href]="getUrl('raiox-online/')" target="_blank">RaioX On-line</a> -->
            </div>
            <div class="d-flex flex-column width-links">
              <!-- <a class="link-footer title" [href]="getUrl('quem-somos/')" target="_blank">&nbsp;</a> -->
              <a class="link-footer title" [href]="getUrl('quem-somos/')" target="_blank">Quem Somos</a>
              <a class="link-footer" style="text-transform: uppercase; color: #16b097; font-weight: 650;"
                [href]="getUrl('entre-em-contato/')" target="_blank">Preciso de ajuda</a>
              <a class="link-footer" style="text-transform: uppercase; color: #16b097; font-weight: 650;"
                [href]="getUrl('marketplace/')" target="_blank">Cadastrar revenda</a>
              <a class="link-footer" style="text-transform: uppercase; color: #16b097; font-weight: 650;"
                [href]="getUrl('termos-de-uso-autoarremate/')" target="_blank">Termos de Uso</a>
              <a class="link-footer" style="text-transform: uppercase; color: #16b097; font-weight: 650;"
                [href]="getUrl('politica-de-privacidade-autoarremate/')" target="_blank">Política de Privacidade</a>
            </div>
            <div class="social-container d-flex flex-row align-items-start justify-content-center"
              style="margin-top: 5px;">
              <a href="https://www.linkedin.com/company/autoarremate/" target="_blank">
                <i class="fa-brands fa-linkedin icon-footer" aria-hidden="true"></i>
              </a>
              <a href="https://www.instagram.com/autoarremate/" target="_blank">
                <i class="fa-brands fa-instagram icon-footer" aria-hidden="true"></i>
              </a>
              <a href="https://www.facebook.com/autoarremate/" target="_blank">
                <i class="fa-brands fa-facebook icon-footer" aria-hidden="true"></i>
              </a>
              <a href="https://wa.me/5511971199876" target="_blank">
                <i class="mdi mdi-whatsapp icon-footer" style="font-size: 26px;"></i>
              </a>
              <a href="tel:551640421197" target="_blank">
                <i class="fa-light fa-phone-alt icon-footer-2" style="color: #fff;"></i>
              </a>
            </div>
            <div class="apps-container flex-grow-1 d-flex flex-lg-row-reverse">
              <div class="d-flex flex-column">
                <!-- <span class="footer-text-2" style="margin-bottom: 4px">Baixe os aplicativos</span> -->
                <div class="apps-button mb-32"
                  style="display:flex; align-items: flex-end; flex-direction: column; gap: 10px;">
                  <a [href]="getUrl('vendedores/aplicativo-raiox/')" target="_blank">
                    <img style="width: 136px; height: 46px;" src="/assets/images/baixar-app-raio-x.svg"
                      alt="Download App RaioX" />
                  </a>
                  <a [href]="getUrl('vendedores/aplicativo-marketplace/')" target="_blank">
                    <img style="width: 169px; height: 48px;" src="/assets/images/baixar-app-marketplace.svg"
                      alt="Download App Marketplace" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="adress-container" *ngIf="!personalization">
    <div class="col-12 px-mdsza566ru8-0">
      <div class="row">
        <div class="adress col-12" style="color: #fff; font-size: 13px; letter-spacing: -0.5px;">
          <strong>HQ | AutoArremate S/A </strong>
          <span class="cnpj">| CNPJ: 34.126.488/0001-10 – </span>
          <span class="line">Rua Alice Alem Saadi, nº 855 – </span>
          <span class="line">Salas nº 1808/1812 – </span>
          <span class="line">Nova Ribeirania, Ribeirão Preto/SP – CEP: 14096-570</span>
          <!-- <span class="copyright">
            © {{ year }} AutoArremate. Todos os direitos reservados.
          </span> -->
        </div>
        <!--  <div class="col-6 d-flex flex-row-reverse">
          <img src="./assets/images/img-selo-IAB-footer.png" alt="Selo IAB" class="footer-stamp">
        </div> -->
      </div>
    </div>
  </div>
  <div class="app-footer-white" *ngIf="!personalization">
    <div class="footer-bottom-white pady-4 container">
      <div class="content-footer-white row">
        <div class="col-6 px-0">
          <span class="copyright">
            ©️ {{ year }} AutoArremate. Todos os direitos reservados.
          </span>
          <!-- <a routerLink="/">
            <img class="size-logo" src="./assets/images/logo-aar.png" />
          </a> -->
        </div>
        <div class="col-6 d-flex flex-row-reverse px-md-0">
          <img class="size-superbid-logo" src="./assets/images/sbx e-trade logo.png" />
        </div>
      </div>
    </div>
  </div>
  <footer *ngIf="personalization">
    <div class="footer-personalization">
      <div class="footer-content">
        <div class="footer-top">

          <div class="logo" *ngIf="!layoutVars.noShowFooterLogo">
            <img [src]="layoutVars.logoUrl" style="min-width: 200px; max-width: 300px;">
          </div>

          <div class="contacts" *ngIf="contacts">
            <h4 class="subtitle">Contatos</h4>
            <ul style="list-style: none; padding: 0; margin: 0;">
              <li *ngFor="let contact of contacts" class="contact">
                <strong>{{ contact.label }}: </strong> <a [href]="contact.href" class="value">{{ contact.contact }}</a>
              </li>
            </ul>
          </div>

          <div style="" class="address" *ngIf="address">
            <h4 class="subtitle">Endereço</h4>
            <p style="font-size: 14px; color: var(--menu-item-color-hover)">
              {{address}}
            </p>
          </div>

        </div>

        <div style="border-top: 1px solid #dee2e6; padding-top: 20px; text-align: center;">

          <div style="margin-bottom: 10px;">
            <a [href]="linkAboutUs" *ngIf="linkAboutUs" target="_blank" class="links">Sobre Nós</a>
            <span *ngIf="linkAboutUs && (linkTerms || linkContact || (layoutVars.footerLinks?.length > 0))"> | </span>

            <a [href]="linkTerms" *ngIf="linkTerms" target="_blank" class="links">Termos de Uso</a>
            <span *ngIf="linkTerms && (linkContact || (layoutVars.footerLinks?.length > 0))"> | </span>

            <a [href]="linkContact" *ngIf="linkContact" target="_blank" class="links">Contato</a>
            <span *ngIf="linkContact && layoutVars.footerLinks?.length > 0"> | </span>

            <ng-container *ngFor="let link of layoutVars.footerLinks; let i = index">
              <a [href]="link.url" target="_blank" class="links">{{ link.label }}</a>
              <span *ngIf="i < layoutVars.footerLinks.length - 1"> | </span>
            </ng-container>
          </div>

          <div style="margin-bottom: 10px;">
            <a [href]="linkLinkedIn" *ngIf="linkLinkedIn" target="_blank" style="margin: 0 10px;">
              <i class="fa-brands fa-linkedin icon-footer" aria-hidden="true"></i>
            </a>
            <a [href]="linkInstagram" *ngIf="linkInstagram" target="_blank" style="margin: 0 10px;">
              <i class="fa-brands fa-instagram icon-footer" aria-hidden="true"></i>
            </a>
            <a [href]="linkFacebook" *ngIf="linkFacebook" target="_blank" style="margin: 0 10px;">
              <i class="fa-brands fa-facebook icon-footer" aria-hidden="true"></i>
            </a>
            <a [href]="linkX" *ngIf="linkX" target="_blank" style="margin: 0 10px;">
              <i class="mdi mdi-twitter icon-footer" aria-hidden="true"></i>
            </a>
          </div>

          <div class="footer-bottom">
            <span class="copyright">&copy; {{year}}. Todos os direitos reservados.</span>
            <a href="https://institucional.superbid.net/" target="_blank" class="powered-by-link">
              <img src="./assets/images/sbx e-trade logo.png?refresh=1" alt="by e-trade sbx">
            </a>
          </div>
          
        </div>
      </div>
    </div>
  </footer>